import { URLS } from '../utils/urls';
import api from './client';

export const measurementService = {
    addMeasurement: async (credentials) => {
        const response = await api.post('measurements', credentials);
        return response.data;
    },
    getAllMeasurements: async () => {
        const response = await api.get('measurements', { base_URL: URLS.baseApi });
        return response.data;
    },
    updateMeasurement: async (id, credentials) => {
        const response = await api.put(`measurements/${id}`, credentials);
        return response.data;
    },
    toggleShow: async (id,) => {
        const response = await api.patch(`measurements/${id}/toggle-show`);
        return response.data;
    },
    deleteMeasurement: async (id) => {
        const response = await api.delete(`measurements/${id}`);
        return response.data;
    },
};